module.exports = __webpack_public_path__ + "img/loginBg.36e16298.png";